import Card from "../../../../components/Card.jsx";
import React from "react";
import {useListBatch} from "./useListBatch";
import TabellaBatch from "./components/TabellaBatch";

export default function ListBatch() {

    const {getBottoniDx} = useListBatch();

    return (
        <Card
            icon={'fas fa-tasks'}
            title={'Batch'}
            getBottoniDx={getBottoniDx}
        >
            <TabellaBatch/>
        </Card>
    );

}